export const GENDER_MEN = {name: 'men', id: 4};
export const GENDER_WOMEN = {name: 'women', id: 5};

export const GENDER_USER_CODE = 0;
export const GENDER_WOMEN_CODE = 1;
export const GENDER_MEN_CODE = 2;
export const GENDER_KIDS_CODE = 3;
export const GENDER_UNISEX_CODE = 4;

export const GENDER_ID_MEN = 4;
export const GENDER_ID_WOMEN = 5;
export const GENDER_ID_UNISEX = 9;
export const GENDER_ID_BOYS = 222;
export const GENDER_ID_GIRLS = 221;
export const CATEGORY_ID_KIDS = 159;

export const GENDER_KEYS_LIST = {
    [GENDER_MEN_CODE]: 'men',
    [GENDER_WOMEN_CODE]: 'women',
    [GENDER_KIDS_CODE]: 'kids',
    [GENDER_UNISEX_CODE]: 'unisex',
};

export const PRODUCT_GENDER = {
    [GENDER_ID_MEN]: GENDER_MEN_CODE,
    [GENDER_ID_WOMEN]: GENDER_WOMEN_CODE,
    [GENDER_ID_UNISEX]: GENDER_UNISEX_CODE,
    [GENDER_ID_BOYS]: GENDER_KIDS_CODE,
    [GENDER_ID_GIRLS]: GENDER_KIDS_CODE,
    [CATEGORY_ID_KIDS]: GENDER_KIDS_CODE,
};
